let appBootstrapPromise = Promise.resolve();
let appBootstrapReady = false;
let layoutHasMounted = false;

export const setAppBootstrapPromise = (promise) => {
	appBootstrapReady = false;
	appBootstrapPromise = Promise.resolve(promise).then(
		() => {
			appBootstrapReady = true;
		},
		() => {
			appBootstrapReady = true;
		}
	);
};

export const getAppBootstrapPromise = () => appBootstrapPromise;

export const isAppBootstrapReady = () => appBootstrapReady;

export const hasLayoutMounted = () => layoutHasMounted;

export const markLayoutMounted = () => {
	layoutHasMounted = true;
};
